<template>
  <v-container>
    <v-layout align-center justify-center>
      <v-dialog
        v-model="cardsDisabled"
        width="300"
        persistent
      >
        <v-card>
          <v-card-text>
            Processando...
            <v-progress-linear indeterminate/>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-form
      ref="form_indicado"
      v-model="valid"
      lazy-validation
    >
      <v-card>
        <v-card-text>
          <v-layout
            row
            wrap
            justify-space-between
            px-3
          >
            <v-flex sm4>
              <v-text-field
                v-if="!indicado.co_indicado_conselho"
                v-model="nu_cpf"
                mask="###.###.###-##"
                label="*CPF do indicado"
                append-icon="person"
                required
                :rules="[rules.required]"
              />
              <v-text-field
                v-else
                v-model="indicado.nu_cpf"
                placeholder="999.999.999-99"
                mask="###.###.###-##"
                label="*CPF do indicado"
                append-icon="person"
                disabled
              />
            </v-flex>
            <v-flex sm7>
              <v-text-field
                v-if="!indicado.co_indicado_conselho"
                v-model="no_nome"
                label="*Nome do indicado"
                append-icon="person"
                required
                disabled
                :rules="[rules.cpfInvalido]"
                :error-messages="nomeComErro"
              />
              <v-text-field
                v-else
                v-model="indicado.no_nome"
                label="*Nome do indicado"
                append-icon="person"
                disabled
              />
            </v-flex>
            <v-flex sm7>
              <v-text-field
                v-if="!indicado.co_indicado_conselho"
                v-model="no_nome_votacao"
                label="*Nome que aparecerá na votação"
                append-icon="person"
                required
                :rules="[rules.required]"
              />
              <v-text-field
                v-else
                v-model="indicado.no_nome_votacao"
                label="*Nome que aparecerá na votação"
                append-icon="person"
                required
                disabled
              />
            </v-flex>
            <v-flex sm4>
              <v-select
                v-if="!indicado.co_indicado_conselho"
                v-model="co_uf"
                :items="listaUF"
                label="*Unidade da federação"
                append-icon="place"
                item-value="co_ibge"
                item-text="no_uf"
                :rules="[rules.required]"
                required
              />
              <v-select
                v-else
                v-model="indicado.uf.co_ibge"
                :items="listaUF"
                label="*Unidade da federação"
                append-icon="place"
                item-value="co_ibge"
                item-text="no_uf"
                disabled
                required
              />
            </v-flex>
            <v-flex sm12>
              <v-checkbox
                v-if="!indicado.co_indicado_conselho"
                v-model="st_declaracao"
                label=" Declaro que o (a) indicado (a) tem, no mínimo, 3 anos de atuação comprovada no campo cultural; é maior de 18 anos; reside na unidade da federação ou macrorregião deste conselho de cultura que o indicou; e não é agente público, exceto participante de instâncias colegiadas (conselhos, comissões, câmaras) na qualidade de conselheiro ou membro."
                :rules="[v => !!v || 'É necessário concordar para salvar!']"
              />
              <v-checkbox
                v-else
                v-model="indicado"
                label=" O indicado acima identificado possui mínimo de 3 anos de atuação no segmento para o qual a entidade se inscreveu.
                                        É brasileiro nato ou naturalizado e maior de 15 anos. Ademais, o indicado não é agente público, exceto participante
                                        de instâncias colegiadas (conselhos, comissões, câmaras) na qualidade de conselheiro ou membro representante da sociedade civil."
                disabled
                :rules="[v => !!v || 'É necessário concordar para salvar!']"
              />
            </v-flex>
            <v-flex
              v-if="!indicado.co_indicado_conselho"
              sm12
              text-sm-center
            >
            <v-btn
                v-if="!loading"
                color="primary"
                round
                :disabled="disabled"
                @click="abrirDialogo"
              >
                Salvar
              </v-btn>
              <v-progress-circular
                v-else
                indeterminate
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-form>
    <v-card v-if="indicado.co_indicado_conselho">
      <v-card-text>
        <v-flex
          sm12
          mx-3
        >
          A documentação deve estar legível, ser digitalizada e anexada em formato PDF (preferencialmente) ou JPEG, cujo tamanho não exceda 100 MB.
        </v-flex>
        <v-flex
          sm12
          mx-3
        >
          <a target="_blank" href="http://cnpc.cultura.gov.br/wp-content/uploads/sites/3/2022/08/ANEXOS-INDICA%C3%87%C3%83O-CONSELHO-1.pdf">Modelo de declaração de autorização de uso de imagem <v-icon
            color="primary"
            small
          >open_in_new</v-icon></a>
        </v-flex>
        <v-flex
          sm12
          mt-1
          mx-3
        >
          <a target="_blank" href="http://cnpc.cultura.gov.br/wp-content/uploads/sites/3/2022/08/ANEXOS-INDICA%C3%87%C3%83O-CONSELHO-1.pdf#page=3">Modelo de declaração de residência<v-icon
            color="primary"
            small
          >open_in_new</v-icon></a>
        </v-flex>
      </v-card-text>
      <v-layout
        row
        wrap
        justify-center
      >
        <v-flex
          v-for="arquivo in arquivos"
          :key="arquivo.tp_arquivo"
          sm4
          mt-2
          pa-3
          style="max-width: 300px;"
          text-xs-center
        >
          <v-card>
            <v-card-title style="height: 200px;">
              <v-flex>{{ arquivo.title }}</v-flex>
            </v-card-title>
            <v-card>
              <v-card-text v-if="(indicado.co_indicado_conselho == null || !indicado.arquivos.find(a => a.tp_arquivo == arquivo.tp_arquivo)) && ativarIndicacaoConselho">
                <SingleFileUpload
                  :co-objeto="indicado.co_indicado_conselho"
                  :tp-arquivo="arquivo.tp_arquivo"
                  file-path="indicacao_conselho"
                  :accepted-file-types="acceptedFileTypes"
                  @upload="desabilitaCards"
                  @removerArquivo="removerArquivo"
                  @sucesso="obterIndicadosPorConselho(coConselho)"
                />
                </v-card-text>
                <v-card-text v-else>
                <v-flex max-width="50">
                  <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                      <v-btn
                        color="blue-grey"
                        outline
                        @click="downloadArquivo(indicado.arquivos.find(a => a.tp_arquivo == arquivo.tp_arquivo).co_arquivo)"
                        v-on="on"
                      >
                        <v-icon

                          dark
                        >
                          cloud_download
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Download</span>
                  </v-tooltip>
                  <v-tooltip v-if="ativarIndicacaoConselho" bottom>
                    <template v-slot:activator="{on}">
                      <v-btn
                        color="error"
                        outline
                        @click="removerArquivo(indicado.arquivos.find(a => a.tp_arquivo == arquivo.tp_arquivo).co_arquivo)"
                        v-on="on"
                      >
                        <v-icon

                          dark
                        >
                          delete
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>

    <v-layout justify-center>
      <dialog-confirmacao
        v-model="modalConfirmacao"
        title="Deseja realmente enviar?"
        text="Os dados enviados não poderão ser alterados posteriormente."
        cancel-text="Não"
        confirm-text="Sim"
        :is-loading="loading"
        @dialog-response="respostaDialog"
      />
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import CardCarregando from '@/modules/shared/components/CardCarregando';
import Validate from '@/modules/shared/util/validate';
import DialogConfirmacao from '@/modules/shared/components/DialogConfirmacao';
import SingleFileUpload from '@/modules/shared/components/SingleFileUpload.vue';


export default {
  name: 'IndicacaoConselhoComponent',
  components: {
    CardCarregando,
    SingleFileUpload,
    DialogConfirmacao,
  },
  props: {
    coConselho: {
      type: Number,
      default: 0,
    },
    indicado: {
      type: Object,
      default: () => {},
    },
    somenteIndeferidos: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listaUF: [],
      cardsDisabled: false,
      nu_cpf: '',
      no_nome: '',
      no_nome_votacao: '',
      co_uf: '',
      st_declaracao: false,
      loading: false,
      valid: false,
      disabled: true,
      nomeComErro: '',
      modalConfirmacao: false,
      rules: {
        required: value => !!value || 'Este campo é obrigatório',
        cpfInvalido: v => !!v || 'CPF não encontrado',
        cpfMin: v => (v && v.length === 11) || 'Mínimo de 11 caracteres',
      },
      arquivos: [
        {
          tp_arquivo: 'foto_indicado',
          title: 'Foto de rosto*',
        },
        {
          tp_arquivo: 'curriculo_indicado',
          title: 'Currículo*',
        },
        {
          tp_arquivo: 'curriculo_resumido_indicado',
          title: 'Currículo resumido para a candidatura*',
        },
        {
          tp_arquivo: 'portifolio_indicado',
          title: 'Portifólio*',
        },
        {
          tp_arquivo: 'cmpr_atuacao',
          title: 'Comprovação, por meio de portaria de designação ou termo de posse, de atuação em instâncias colegiadas nos últimos 10 anos, se houver',
        },
        {
          tp_arquivo: 'cpf_indicado',
          title: 'Cópia do documento de identificação (conforme item 2.8 deste edital) e CPF*',
        },
        {
          tp_arquivo: 'cmpres_indicado',
          title: 'Comprovante de residência com o nome do indicado ou declaração de residência (ANEXO 6)*',
        },
        {
          tp_arquivo: 'autorizacao_indicado',
          title: 'Declaração que autoriza a Secretaria Especial da Cultura do Ministério do Turismo a divulgar as imagens e informações contidas na inscrição e que responsabiliza o candidato pelos documentos e materiais apresentados (ANEXO 2 do edital)*',
        },
        {
          tp_arquivo: 'declaracao_indicado',
          title: 'Declaração do indicado de que possui disponibilidade para compor o Conselho Nacional de Política Cultural - CNPC, no triênio 2022/2025 (ANEXO 2 do edital)*',
        },
        {
          tp_arquivo: 'delico_indicado',
          title: 'Documento que comprove a deliberação do Conselho, presencial ou virtual, para indicação dos candidatos*',
        },
        {
          tp_arquivo: 'termo_indicacao',
          title: 'Termo de indicação de representante do Conselho de Cultura assinado pelo presidente do conselho (ANEXO 5)*',
        },
      ],
      acceptedFileTypes: 'image/jpeg, application/pdf',
    };
  },

  computed:{
    ...mapGetters({
        ativarIndicacaoConselho: 'fase/ativarIndicacaoConselho',
        estados: 'localidade/estados',
        indicadosConselho: 'conselho/indicadosConselho',
    })
  },
  watch: {
    nu_cpf(valor) {
      this.no_nome = '';
      this.nomeComErro = 'CPF inválido';
      this.disabled = true;
      if (valor.length === 11 && Validate.isCpfValido(valor)) {
        this.consultarCPF(valor).then((response) => {
          const { data } = response.data;
          this.no_nome = data.nmPessoaFisica;
          this.disabled = false;
        });
        this.nomeComErro = '';
      }
    },
    indicadosConselho(indicados){
      this.indicado = indicados.find(i => i.co_indicado_conselho == this.indicado.co_indicado_conselho);
      this.modalConfirmacao = false;
      this.cardsDisabled = false;
      this.loading = false;
    },
  },
  methods: {
    ...mapActions({
      cadastrarIndicado: 'conselho/cadastrarIndicado',
      consultarCPF: 'pessoa/consultarCPF',
      downloadArquivo: 'shared/downloadArquivo',
      excluirArquivo: 'conselho/excluirArquivoIndicacao',
      obterIndicadosPorConselho: 'conselho/obterIndicadosPorConselho'
    }),
    registrar() {
      if (!this.$refs.form_indicado.validate()) {
        return false;
      }
      this.loading = true;
      this.cadastrarIndicado(
        {
          nu_cpf: this.nu_cpf,
          no_nome: this.no_nome,
          no_nome_votacao: this.no_nome_votacao,
          co_uf: this.co_uf,
          co_conselho: this.coConselho,
        },
      ).finally(() => {
        this.obterIndicadosPorConselho(this.coConselho);
      });
    },
    removerArquivo(co_arquivo) {
        this.cardsDisabled = true;
        this.excluirArquivo({ coIndicado: this.indicado.co_indicado_conselho, coArquivo: co_arquivo })
        .then(response => this.indicado = response.data)
        .finally(() => this.cardsDisabled = false);
     },
     desabilitaCards(){
      this.cardsDisabled = true;
     },
    abrirDialogo() {
      if (!this.$refs.form_indicado.validate()) {
        return false;
      }
      this.modalConfirmacao = true;
      return true;
    },
    respostaDialog(tipoResposta) {
      if (tipoResposta) {
        this.registrar();
      } else {
        this.modalConfirmacao = false;
      }
    },
  },
  mounted() {
    this.listaUF = this.estados;
  },
};
</script>
